import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Final CTA — shares the same dark field as the footer. No hard seam.
// A subtle gradient hands off into the footer for a seamless premium flow.
const FinalCTA = () => {
  return (
    <section
      className="relative isolate overflow-hidden bg-abayle-green-dark"
      data-testid="final-cta"
    >
      {/* Subtle ambient gold wash (top) */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 0%, #C9A13B 0, transparent 45%), radial-gradient(circle at 85% 100%, #C9A13B 0, transparent 40%)",
        }}
      />

      <div className="relative container-abayle py-16 sm:py-14 sm:py-20 lg:py-24">
        <div className="max-w-4xl">
          <span className="eyebrow mb-5 block">Let&apos;s Work Together</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-[52px] font-bold text-white tracking-tight leading-[1.08]">
            Need a Reliable Partner <br className="hidden sm:block" />
            <span className="text-abayle-gold">in Somalia?</span>
          </h2>
          <p className="mt-6 text-white/80 max-w-2xl text-base lg:text-lg leading-relaxed">
            Talk to Abayle Logistics and Trading for support across logistics, global trade, clearance,
            car sales, and car rental.
          </p>
          <div className="mt-10">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-abayle-gold text-abayle-green border-2 border-abayle-gold px-7 py-3 font-semibold rounded-md transition-all duration-300 hover:bg-white hover:border-white"
              data-testid="cta-contact-us"
            >
              Contact Us
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>

      {/* Seamless gradient handoff into footer (no hard line) */}
      <div className="pointer-events-none absolute left-0 right-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-abayle-green-darker" />
    </section>
  );
};

export default FinalCTA;
